"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProfileFAQ = void 0;
const tmpls_1 = require("./tmpls");
const ClassesTags_1 = require("../ClassesTags");
class CmpProfileFAQ extends tmpls_1.CmpProfileFAQBase {
    constructor() {
        super();
        for (const item of this.ctrls.list.q('li').all) {
            item.q('button').first.onclick = () => {
                item.flipClass(ClassesTags_1.ClassesTags.Active);
            };
        }
    }
}
exports.CmpProfileFAQ = CmpProfileFAQ;
//# sourceMappingURL=CmpProfileFAQ.js.map